<template>
  <div class="admin-translate">
    <header-title title="Traducciones Categorías"></header-title>
    <v-row align="start">
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-text-field
          outlined
          dense
          label="Buscar"
          v-model="search"
          class="select-box ml-2"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <v-container fluid>
      <template>
        <div v-for="category in paginatedData" :key="category.id">
          <Translate
            :data="category"
            @saveToCollection="saveToCategoryCollection"
          ></Translate>
        </div>
        <div class="text-center">
          <v-pagination
            v-model="pageNumber"
            :length="Math.ceil(filteredCategory.length / size)"
            circle
            @input="nextPage"
            :total-visible="6"
            color="black"
          ></v-pagination>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import Loader from "../../../components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import Translate from "@/components/admin/translate/Translate";
import { categoriesCollection } from "@/collections/categories";
import { updateCategory } from "@/collections/categories";

export default {
  name: "TranslateCategory",
  components: {
    HeaderTitle,
    Loader,
    Translate
  },
  data() {
    return {
      dialogLoader: false,
      search: "",
      categoriesCollection: [],
      pageNumber: 1,
      size: 2
    };
  },
  firestore() {
    return {
      categoriesCollection: categoriesCollection
    };
  },
  mounted() {
    setTimeout(() => {
      this.dialogLoader = false;
    }, 1000);
  },
  computed: {
    filteredCategory() {
      let _category = [...this.categoriesCollection];

      return this.search
        ? _category.filter(category =>
            category?.name?.toLowerCase().includes(this.search?.toLowerCase())
          )
        : _category;
    },
    paginatedData() {
      let start = this.pageNumber * this.size - this.size;
      let end = start + this.size;
      return this.filteredCategory.slice(start, end);
    }
  },
  methods: {
    nextPage(page) {
      this.pageNumber = page;
    },
    async saveToCategoryCollection(input) {
      try {
        await updateCategory(input.id, input);
        this.showSuccessMessage("Traducciones Categorías actualizado");
      } catch (error) {
        this.setlogError(
          "save/update_category",
          "Obtained error message in saveToCategoryCollection()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    }
  }
};
</script>
